export default __webpack_public_path__ + "static/media/compltn.a8e9bb64.jfif";